import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Utente } from '../models/utente.model';


@Injectable({
  providedIn: 'root',
})
export class UtentiService{
  apiUrl: string = `${environment.apiUrl}`+"utente";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}
    

  get(): Observable<any> {
    this.apiUrl =`${environment.apiUrl}`+"utente";
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  } 

  getByIdAuth0(idAuth0:String): Observable<any> {
    const url =this.apiUrl+"/auth0/"+idAuth0;
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(url, httpOptions);
  }


  crea(dipendente:Utente): Observable<any> {
    //this.apiUrl =`${environment.apiUrl}/cdc`;
    
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, dipendente, httpOptions)
   /*  .pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('creaCdc', []))) */
      ;
  }
  

  modifica(utente:Utente): Observable<any> {
    //this.apiUrl =this.apiUrl+"/"+utente.id;

    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+utente.id, utente, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificaUtente', []))
    );
  }

  elimina(idUtente:string): Observable<any> {
    //this.apiUrl =this.apiUrl+"/"+idUtente;
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idUtente, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminaUtente', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };
}
